import _sfc_main from "./BuyBoxMembership2.mjs";
/* empty css                   */
import _export_sfc from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const BuyBoxMembership = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-a116a8b9"]]);
export {
  BuyBoxMembership as default
};
//# sourceMappingURL=BuyBoxMembership.mjs.map
